import { API_BASE_URL } from './apiConfig';

const ANON_KEY = 'reopsai_anon_id';
const SESSION_KEY = 'reopsai_session_id';
const SESSION_TS_KEY = 'reopsai_session_ts';
const SESSION_IDLE_MS = 30 * 60 * 1000;
const FLUSH_LIMIT = 20;
const FLUSH_INTERVAL_MS = 5000;

let queue = [];
let flushTimer = null;

function randomId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `id_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
}

function readStorage(key) {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

function writeStorage(key, value) {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // ignore
  }
}

export function getAnonymousId() {
  let value = readStorage(ANON_KEY);
  if (!value) {
    value = randomId();
    writeStorage(ANON_KEY, value);
  }
  return value;
}

export function getSessionId() {
  const now = Date.now();
  const lastTs = Number(readStorage(SESSION_TS_KEY) || 0);
  let sessionId = readStorage(SESSION_KEY);
  if (!sessionId || !lastTs || now - lastTs > SESSION_IDLE_MS) {
    sessionId = randomId();
    writeStorage(SESSION_KEY, sessionId);
  }
  writeStorage(SESSION_TS_KEY, String(now));
  return sessionId;
}

function scheduleFlush() {
  if (flushTimer) return;
  flushTimer = setTimeout(() => {
    flushTimer = null;
    flushProductEvents();
  }, FLUSH_INTERVAL_MS);
}

export function trackProductEvent(eventName, payload = {}) {
  if (typeof window === 'undefined') return;
  queue.push({
    event_name: eventName,
    path: payload.path,
    occurred_at: new Date().toISOString(),
    meta: payload.meta || undefined,
    funnel_id: payload.funnel_id,
    step_id: payload.step_id,
  });
  if (queue.length >= FLUSH_LIMIT) {
    flushProductEvents();
  } else {
    scheduleFlush();
  }
}

export function trackPageView(path) {
  trackProductEvent('page_viewed', { path });
}

export async function flushProductEvents() {
  if (!queue.length || typeof window === 'undefined') return;
  const events = queue.splice(0, queue.length);
  const body = JSON.stringify({
    session_id: getSessionId(),
    anonymous_id: getAnonymousId(),
    events,
  });

  try {
    const token = window.localStorage.getItem('jwt');
    const headers = { 'Content-Type': 'application/json' };
    if (token) headers.Authorization = `Bearer ${token}`;

    if (navigator.sendBeacon && !token) {
      const blob = new Blob([body], { type: 'application/json' });
      navigator.sendBeacon(`${API_BASE_URL}/analytics/collect`, blob);
      return;
    }

    await fetch(`${API_BASE_URL}/analytics/collect`, {
      method: 'POST',
      headers,
      body,
      keepalive: true,
    });
  } catch {
    // best-effort: put back a small sample if send failed
    queue = events.slice(0, 5).concat(queue);
  }
}

if (typeof window !== 'undefined') {
  window.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      flushProductEvents();
    }
  });
  window.addEventListener('pagehide', () => {
    flushProductEvents();
  });
}
